/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_YesInputs */

const es_components_ask_questions_label_yes = /** @type {(inputs: Components_Ask_Questions_Label_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const en_components_ask_questions_label_yes = /** @type {(inputs: Components_Ask_Questions_Label_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Components_Ask_Questions_Label_YesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_yes = /** @type {((inputs?: Components_Ask_Questions_Label_YesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_YesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_yes(inputs)
	return en_components_ask_questions_label_yes(inputs)
});
export { components_ask_questions_label_yes as "components.ask_questions.label.yes" }